export default __webpack_public_path__ + "static/media/regulatory--do-not-block-intersection--g1.18bccc47.png";